import Sider from 'antd/lib/layout/Sider';
import Layout, { Content } from 'antd/lib/layout/layout';
import styled from 'styled-components';

import PoweredByComponent from 'components/PoweredBy/PoweredBy';
import { COLOR } from 'styles/styledComponents/color.model';

import { ReactComponent as LogoSVG } from './Assets/Logo-Billon.svg';
import { ReactComponent as WatermarkSVG } from './Assets/Water-mark-logo.svg';

export const PageLayout = styled(Layout)`
  height: 100vh;
  min-height: 720px;
`;

export const SiderContainer = styled(Sider)`
  padding: 90px 86px 58px 106px;
  background-color: ${COLOR.WHITE};
`;

export const SiderContent = styled.div`
  height: 100%;
  position: relative;
`;

export const WelcomeText = styled.h1`
  color: ${COLOR.OUTER_SPACE};
  text-align: left;
  font-size: 37px;
  font-weight: bold;
`;

export const DescriptionText = styled.h2`
  text-align: left;
  font-size: 19px;
  color: ${COLOR.MID_GREY};
`;

export const EntryContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

export const Background = styled(Content)`
  position: relative;
  overflow: hidden;
  background-color: ${COLOR.MID_GREY};
`;

export const Watermark = styled(WatermarkSVG)`
  position: absolute;
  right: 50px;
  bottom: -120px;
  width: 100%;
  min-width: 800px;
`;

export const Logo = styled(LogoSVG)`
  position: absolute;
  right: 40px;
  top: 40px;
`;

export const PoweredBy = styled(PoweredByComponent)`
  position: absolute;
  bottom: 0px;
`;
